/**
 * Geanimeerde visuals in het showcase-blok (template-parts/visuals/*).
 * De markup staat in de eindstand; hier wordt de animatie afgespeeld,
 * alleen zolang de visual in beeld is. Bij prefers-reduced-motion blijft de eindstand staan.
 */

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

function watch(root) {
    const state = { visible: false };
    if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => {
            entries.forEach((e) => { state.visible = e.isIntersecting; });
        }, { rootMargin: '100px' }).observe(root);
    } else {
        state.visible = true;
    }
    // wacht ms, en pauzeer daarna zolang de visual buiten beeld is
    state.wait = async (ms) => {
        await sleep(ms);
        while (!state.visible) await sleep(250);
    };
    return state;
}

/* ---------- Chat ---------- */
const CHAT = [
    { q: 'Welke hardloopschoenen zijn goed voor beginners?', a: 'Voor beginners zijn demping en een goede pasvorm belangrijker dan gewicht. Laat je looppas analyseren in een speciaalzaak, dan weet je welk type schoen bij je past.', t: 'Loopwinkel Noord', d: 'Gratis looptest in de winkel', l: 'LN' },
    { q: 'Wat kost het om een airco te laten plaatsen?', a: 'Dat hangt af van het vermogen, het aantal ruimtes en de lengte van de leidingen. Vraag een paar offertes op met een bezoek aan huis, dan weet je waar je aan toe bent.', t: 'Klimaat Direct', d: 'Offerte binnen 24 uur', l: 'KD' },
    { q: 'Ik zoek een boekhouder voor mijn eenmanszaak', a: "Let op ervaring met zzp'ers en een vaste prijs per maand. Veel boekhouders combineren de btw-aangifte en de jaarrekening in één pakket.", t: 'Cijferwerk', d: "Vaste prijs voor zzp'ers", l: 'CW' },
];

async function chat(root) {
    const s = watch(root);
    const q = root.querySelector('.mcv-chat__q');
    const a = root.querySelector('.mcv-chat__a');
    const inp = root.querySelector('.mcv-chat__input');
    const field = root.querySelector('.mcv-chat__field');
    const ad = root.querySelector('.mcv-chat__promo');
    let i = 0;

    await s.wait(0);
    while (root.isConnected) {
        const d = CHAT[i++ % CHAT.length];
        root.className = 'mcv-chat is-playing';
        q.textContent = ''; a.textContent = '';
        field.textContent = 'Stel een vraag'; inp.classList.remove('is-filled');

        await s.wait(700);
        inp.classList.add('is-filled'); field.textContent = '';
        for (const ch of d.q) { field.textContent += ch; await s.wait(38); }

        await s.wait(450);
        q.textContent = d.q; field.textContent = 'Stel een vraag'; inp.classList.remove('is-filled');
        root.classList.add('is-q');

        await s.wait(500); root.classList.add('is-typing');
        await s.wait(1100); root.classList.remove('is-typing');

        const words = d.a.split(' ');
        for (let k = 0; k < words.length; k++) { a.textContent += (k ? ' ' : '') + words[k]; await s.wait(55); }

        await s.wait(500);
        ad.querySelector('.mcv-chat__logo').textContent = d.l;
        ad.querySelector('strong').textContent = d.t;
        ad.querySelector('span').textContent = d.d;
        root.classList.add('is-promo');

        await s.wait(4200); root.classList.add('is-out');
        await s.wait(450);
    }
}

/* ---------- Website opbouwen ---------- */
const NAMES = [['Studio Noord', 'studionoord.nl'], ['Bureau Vos', 'bureauvos.nl'], ['Atelier Delta', 'atelierdelta.nl'], ['Jouw bureau', 'jouwbureau.nl']];

async function build(root) {
    const s = watch(root);
    const blks = root.querySelectorAll('.mcv-build__blk');
    const nms = root.querySelectorAll('.mcv-build__nm');
    const setName = (n) => nms.forEach((e) => { e.textContent = e.dataset.v === 'url' ? n[1] : n[0]; });

    await s.wait(0);
    while (root.isConnected) {
        blks.forEach((b) => b.classList.remove('is-on'));
        setName(NAMES[0]);
        await s.wait(500);
        for (const b of blks) { b.classList.add('is-on'); await s.wait(380); }
        await s.wait(1400);
        for (let n = 1; n < NAMES.length; n++) {
            nms.forEach((e) => e.classList.add('is-swap'));
            await s.wait(320);
            setName(NAMES[n]);
            nms.forEach((e) => e.classList.remove('is-swap'));
            await s.wait(n === NAMES.length - 1 ? 3200 : 1700);
        }
    }
}

/* ---------- AI-ontwerptool ---------- */
const OCC = [['HOERA 40!', 'Sanne · zaterdag 14 juni'], ['25 JAAR', 'Bakkerij Smit · sinds 2001'], ['WE ZIJN OPEN', 'Nieuwe winkel · Vismarkt 12']];
const COMBOS = [[1, 0], [0, 1], [2, 2]];

async function generate(root) {
    const s = watch(root);
    const g0 = root.querySelectorAll('[data-g="0"] span');
    const g1 = root.querySelectorAll('[data-g="1"] span');
    const go = root.querySelector('.mcv-gen__go');
    const dz = root.querySelectorAll('.mcv-gen__dz');
    const open = root.querySelector('.mcv-gen__open');

    const fill = (o) => dz.forEach((d, i) => {
        d.className = 'mcv-gen__dz v' + (i + 1);
        d.innerHTML = '<div class="mcv-gen__ct"><span class="mcv-gen__big"></span><span class="mcv-gen__sm"></span></div>';
        d.querySelector('.mcv-gen__big').textContent = OCC[o][0];
        d.querySelector('.mcv-gen__sm').textContent = OCC[o][1];
    });
    const reset = () => {
        [...g0, ...g1].forEach((c) => c.classList.remove('is-on'));
        dz.forEach((d) => { d.className = 'mcv-gen__dz'; d.innerHTML = ''; });
        open.classList.remove('is-on');
    };

    let i = 0;
    await s.wait(1500); // eerst even de eindstand laten zien
    while (root.isConnected) {
        const c = COMBOS[i++ % COMBOS.length];
        reset();
        root.className = 'mcv-gen st-' + c[1];
        await s.wait(700); g0[c[0]].classList.add('is-on');
        await s.wait(650); g1[c[1]].classList.add('is-on');
        await s.wait(650); go.classList.add('is-press');
        await s.wait(160); go.classList.remove('is-press');
        dz.forEach((d) => d.classList.add('is-load'));
        await s.wait(1300); fill(c[0]);
        const shown = [...dz].filter((d) => d.offsetParent);
        for (const d of shown) { d.classList.add('is-show'); await s.wait(220); }
        await s.wait(700); shown[i % shown.length].classList.add('is-pick');
        await s.wait(400); open.classList.add('is-on');
        await s.wait(2800);
    }
}

/* ---------- Reactietijd ---------- */
async function steps(root) {
    const s = watch(root);
    const items = [...root.querySelectorAll('.mcv-steps__row > div')];
    const to = (n) => items.forEach((el, i) => el.classList.toggle('is-on', i <= n));

    // één keer afspelen zodra hij in beeld komt, daarna stil laten staan
    await s.wait(0);
    to(-1);
    await s.wait(500);
    for (let n = 0; n < items.length; n++) { to(n); await s.wait(600); }
}

const VISUALS = { chat, build, generate, steps };

export function initVisuals() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('[data-visual]').forEach((root) => {
        const fn = VISUALS[root.dataset.visual];
        if (fn) fn(root).catch(() => {});
    });
}
